import { Component, EventEmitter, Output } from "@angular/core";
import { CustomModal } from "@modules/core/components/base-modals";

@Component({
	selector: "trade-savings-intro",
	templateUrl: "./trade-savings-intro-modal.component.html",
	styleUrls: ["./trade-savings-intro-modal.component.scss"],
	standalone: false
})
export class TradeSavingsIntroModalComponent extends CustomModal {
	@Output() public onButtonClicked: EventEmitter<void> = new EventEmitter<void>();

	public constructor() {
		super();
	}
}
